import { useState } from 'react';
import { MdPause } from "react-icons/md";

import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import AudioPlaylist from '@/shared-components/audio/components/AudioPlaylist';
import PlayIcon from '@/shared-components/icons/components/actions/Playicon';
import CustomInputRange from '@/shared-components/inputs/components/CustomInputRange';
import Text from '@/shared-components/text/components/Text';

import './styles/AudioPlayer.css';

export default function AudioPlayer({ audioId, deleteAudio, previewMode, disabled = false }) {
  const t = useTranslations('common.forms.add_artwork');
  // bloqueo para evitar llamadas rápidas a play/pause
  const [clickLocked, setClickLocked] = useState(false);

  return (
    <AudioPlaylist audioTracks={[`${config.app.audioServiceDomain}/${audioId}`]}>
      {({ loading, currentTime, sliderProps, togglePlayPause, audioState }) => {
        // wrapper que bloquea clicks hasta el siguiente frame
        function handlePlayPause() {
          if (disabled || clickLocked) return;
          setClickLocked(true);
          // togglePlayPause normalmente llama a audio.play() o audio.pause()
          togglePlayPause();
          // desbloquear tras un repaint
          requestAnimationFrame(() => setClickLocked(false));
        }

        return (
          <div className={`add-artwork-audio-player__container${disabled ? ' is-disabled' : ''}`}>
            <div
              className={`add-artwork-audio-player__play-pause-button${disabled ? ' is-disabled' : ''}`}
              onClick={handlePlayPause}
            >
              {audioState === "AUDIO_PAUSED"
                ? <PlayIcon className={`add-artwork-audio-player__play-pause-icon play${disabled ? ' is-disabled' : ''}`} />
                : <MdPause className={`add-artwork-audio-player__play-pause-icon pause${disabled ? ' is-disabled' : ''}`} />
              }
            </div>
            <Text
              className={[
                `add-artwork-audio-player__currentTime${disabled ? ' is-disabled' : ''}`,
              ].filter(Boolean).join(" ")}>
              {loading ? "-:-" : currentTime}
            </Text>
            <CustomInputRange
              className={`add-artwork-audio-player__slider${disabled ? ' is-disabled' : ''}`}
              defaultValue={sliderProps.defaultValue}
              maxValue={sliderProps.max}
              reference={sliderProps.ref}
              onInput={sliderProps.onInput}
              onMouseUp={sliderProps.onMouseUp}
              onTouchEnd={sliderProps.onTouchEnd}
              onKeyDown={sliderProps.onKeyDown}
              thumb
              disabled={disabled}
            />
            {!previewMode && (
              <Text
                className={[
                  `add-artwork-audio-player__delete-audio${disabled ? ' is-disabled' : ''}`,
                ].filter(Boolean).join(" ")}
                onClick={disabled ? undefined : deleteAudio}>
                {t('media.delete')}
              </Text>
            )}
          </div>
        );
      }}
    </AudioPlaylist>
  );
}
